import type { CityConfig } from "../city-template/types";

export const saintClairShoresConfig: CityConfig = {
  city: "Saint Clair Shores",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "saint-clair-shores",
  route: "/cities/saint-clair-shores",
  title: "Emergency Passport Saint Clair Shores MI | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Saint Clair Shores, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Saint Clair Shores, Warren, Roseville, Grosse Pointe, and all eastern Macomb County residents. Nautical Mile and lakefront travel expertise. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Saint Clair Shores, MI",
  heroSubtitle: "Saint Clair Shores travelers — Nautical Mile boaters, Lake Saint Clair waterfront residents, Grosse Pointe commuters, and international families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of eastern Macomb County and the Lake Saint Clair shoreline.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20Saint%20Clair%20Shores%20Michigan%20along%20Lake%20Saint%20Clair%2C%20Nautical%20Mile%20waterfront%20district%20with%20boats%20docked%20in%20the%20marina%2C%20lakefront%20homes%20and%20cottages%2C%20vibrant%20shoreline%20with%20blue%20water%2C%20warm%20summer%20light%2C%20no%20text%20no%20people%2C%20cinematic%20landscape%20photography&width=1800&height=700&seq=saint-clair-shores-hero-001&orientation=landscape",
  heroImageAlt: "Saint Clair Shores Michigan Nautical Mile waterfront along Lake Saint Clair with marina and boats",
  geoPosition: "42.4974;-82.8964",
  geoPlacename: "Saint Clair Shores, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "211 W. Fort St, Suite 1300, Detroit, MI 48226",
    distance: "Approximately 20 miles southwest of Saint Clair Shores — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Saint Clair Shores", zips: "48080, 48081, 48082" },
    { name: "Warren", zips: "48088, 48089, 48091, 48092, 48093" },
    { name: "Roseville", zips: "48066" },
    { name: "Eastpointe", zips: "48021" },
    { name: "Grosse Pointe", zips: "48230, 48236" },
    { name: "Fraser", zips: "48026" },
    { name: "Center Line", zips: "48015" },
    { name: "Harper Woods", zips: "48225" },
    { name: "Mount Clemens", zips: "48043, 48046" },
    { name: "Clinton Township", zips: "48310, 48311, 48312, 48313, 48314" },
    { name: "Sterling Heights", zips: "48310, 48311, 48312, 48313, 48314" },
    { name: "Detroit", zips: "48224, 48225, 48230, 48236" },
    { name: "New Baltimore", zips: "48047" },
    { name: "Chesterfield", zips: "48047, 48051" },
    { name: "Harrison Township", zips: "48045" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "Lakefront Travel Expertise", desc: "Boating, cruise, and international travel passport support" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from anywhere in eastern Macomb County" },
  ],
  internalLinks: [
    { name: "Expedited passport in Warren, MI", route: "/cities/warren" },
    { name: "Emergency passport services in Roseville, MI", route: "/cities/roseville-mi" },
    { name: "Urgent passport services in Detroit, MI", route: "/cities/detroit" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Saint Clair Shores, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the 20-mile drive or appointment wait. Saint Clair Shores residents can ship from any UPS or FedEx in eastern Macomb County.",
  fpcOfficeDistance: "Serving Saint Clair Shores, Warren, Roseville, Eastpointe, Grosse Pointe, Fraser, Center Line, Harper Woods, and all of eastern Macomb County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Saint Clair Shores and the greater eastern Macomb County area. From the Nautical Mile waterfront to the Grosse Pointe border, from the Warren corridor to the Lake Saint Clair shoreline — we serve all of the eastern Detroit metro region. The Detroit Passport Agency is approximately 20 miles southwest, and our couriers have direct access to it.",
  nearbyCitiesIntro: "We serve Saint Clair Shores and all eastern Macomb County communities including Warren, Roseville, Eastpointe, Grosse Pointe, Fraser, Center Line, Harper Woods, Mount Clemens, Clinton Township, Sterling Heights, New Baltimore, Chesterfield, and Harrison Township. We also serve lakefront and boating travelers throughout the Lake Saint Clair region.",
  howItWorksIntro: "Most Saint Clair Shores travelers complete everything online and ship documents overnight. No driving to the Detroit Passport Agency or waiting weeks for an appointment — our registered couriers handle the submission for you.",
  mistakesIntro: "Saint Clair Shores is a unique lakefront community with heavy boating, cruise, and international travel. Here are the most common passport mistakes we see from eastern Macomb County travelers.",
  testimonialsIntro: "Saint Clair Shores travelers — from Nautical Mile boaters to Grosse Pointe commuters to international families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Saint Clair Shores, MI? Here are the most common ones we hear from eastern Macomb County and Lake Saint Clair travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person in downtown Detroit", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for boating and cruise travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Saint Clair Shores travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute cruise departures, family emergencies, and lake travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Lakefront and cruise travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Saint Clair Shores adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your eastern Macomb County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Saint Clair Shores residents and families — including international students, new citizens, and eastern Macomb County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Saint Clair Shores residents who lost their passport before international travel or cruise departure.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Saint Clair Shores-area families planning international vacations, cruises, or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Saint Clair Shores and eastern Macomb County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Saint Clair Shores MI", description: "Urgent passport processing for Saint Clair Shores Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Saint Clair Shores MI", description: "Fast passport renewal for Saint Clair Shores Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Saint Clair Shores MI", description: "New passport application services for Saint Clair Shores Michigan residents applying for their first passport." },
    { name: "Child Passport Saint Clair Shores MI", description: "Minor passport services for Saint Clair Shores Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Michelle R.",
      location: "Saint Clair Shores, MI",
      rating: 5,
      text: "Cruise out of Miami in 6 days and my passport was expired. Fast Passport Center handled the renewal in 3 days. I shipped from the UPS Store on Greater Mack and had my passport back before I even started packing.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Thomas B.",
      location: "Warren, MI",
      rating: 5,
      text: "Business trip to Toronto in 4 days and my passport was lost. Fast Passport Center walked me through the replacement process and had a new passport in my hands in 48 hours. The courier service is incredible — no driving to Detroit.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Sandra K.",
      location: "Grosse Pointe, MI",
      rating: 5,
      text: "Family of five going to Mexico for spring break — 10 days notice. Fast Passport Center processed all five passports in 5 days. They caught a mistake on one of my kid's forms that would have delayed us. Worth every penny.",
      service: "Family Passport Bundle",
    },
    {
      name: "Kevin D.",
      location: "Roseville, MI",
      rating: 5,
      text: "Boating trip to the Thousand Islands and realized my passport was expiring too soon. Fast Passport Center got me a renewed passport in 2 days. I shipped from the FedEx on Gratiot and everything was seamless.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "scs-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "211 W. Fort St, Suite 1300",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 20 miles southwest of Saint Clair Shores — appointments typically booked 2 weeks out",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "scs-2",
      name: "Saint Clair Shores Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "23031 Greater Mack Ave",
      city: "Saint Clair Shores",
      state: "MI",
      zip: "48080",
      phone: "(586) 773-2660",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Saint Clair Shores — near the Nautical Mile",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Saint Clair Shores acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to Nautical Mile, lakefront, and eastern Macomb County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "scs-3",
      name: "Roseville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "27310 Gratiot Ave",
      city: "Roseville",
      state: "MI",
      zip: "48066",
      phone: "(586) 776-7720",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Roseville — approximately 5 miles north of Saint Clair Shores",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Roseville and northern Saint Clair Shores residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "scs-4",
      name: "Warren Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "28422 Dequindre Rd",
      city: "Warren",
      state: "MI",
      zip: "48092",
      phone: "(586) 573-6000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Warren — approximately 8 miles west of Saint Clair Shores",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Warren and western Macomb County residents. Larger facility with more appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "scs-5",
      name: "Eastpointe Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "18000 E 9 Mile Rd",
      city: "Eastpointe",
      state: "MI",
      zip: "48021",
      phone: "(586) 776-3430",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Eastpointe — approximately 10 miles southwest of Saint Clair Shores",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Eastpointe and southern Macomb County residents. Book early during summer travel season.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in eastern Macomb County" },
    { feature: "Lakefront & Cruise Expertise", agency: "No tailored advice", fpc: "Yes — Nautical Mile, Lake Saint Clair, and cruise travel" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Saint Clair Shores boaters and cruise travelers often discover passport issues right before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for Cruise Air Travel",
      description: "Many Saint Clair Shores cruise travelers assume a passport card is sufficient — but if your cruise involves any air travel (to the departure port or from a foreign port), you need a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at eastern Macomb County acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Cruise Line Passport Requirements",
      description: "Different cruise lines have different passport requirements for closed-loop vs. open-loop cruises. Saint Clair Shores Nautical Mile boaters should verify their specific cruise line's passport rules before departure.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in eastern Macomb County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Saint Clair Shores, Warren, or Roseville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no drive or appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your eastern Macomb County address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport agency to Saint Clair Shores, MI?", a: "The Detroit Passport Agency is the nearest regional passport agency to Saint Clair Shores, located at 211 W. Fort St, Suite 1300, Detroit, MI 48226 — approximately 20 miles southwest. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access and can submit applications without individual appointments, saving you the drive and wait." },
    { q: "How fast can I get an emergency passport in Saint Clair Shores?", a: "Fast Passport Center offers emergency passport processing in Saint Clair Shores, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to drive to downtown Detroit or take a day off work." },
    { q: "Do I need a passport for a cruise from Saint Clair Shores?", a: "For closed-loop cruises (departing and returning to the same U.S. port), U.S. citizens can use a passport book, passport card, or enhanced driver's license. However, a passport book is strongly recommended because it provides the most flexibility if you need to fly home from a foreign port due to emergency, illness, or missed departure. For any cruise involving international air travel, a passport book is required. Always check your specific cruise line's requirements." },
    { q: "Can I get an expedited passport in the Saint Clair Shores suburbs like Warren or Roseville?", a: "Absolutely. Fast Passport Center serves all of eastern Macomb County including Warren, Roseville, Eastpointe, Grosse Pointe, Fraser, Center Line, Harper Woods, Mount Clemens, Clinton Township, Sterling Heights, and all surrounding communities. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Saint Clair Shores-area travelers use for international flights?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub for Saint Clair Shores and eastern Macomb County travelers — approximately 35 miles west. DTW offers direct flights to London, Amsterdam, Tokyo, Mexico City, Cancun, and dozens of other international destinations. Coleman A. Young Detroit City Airport is a smaller city airport primarily for domestic/charter flights. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Saint Clair Shores, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Saint Clair Shores-area residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Saint Clair Shores, Warren, Roseville, and Eastpointe offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve the Upper Peninsula from Saint Clair Shores?", a: "Yes. Fast Passport Center serves all of Michigan including the Upper Peninsula. Our courier service is especially valuable for remote UP communities, which would otherwise face an 8+ hour drive to the Detroit Passport Agency. We serve Marquette, Sault Ste. Marie, Houghton, Escanaba, and all UP communities — you just ship your documents overnight and we handle everything from there." },
  ],
  photoLocations: [
    { name: "Walgreens — Greater Mack Ave", address: "23000 Greater Mack Ave, Saint Clair Shores, MI 48080", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Saint Clair Shores", address: "25000 Jefferson Ave, Saint Clair Shores, MI 48080", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Saint Clair Shores", address: "23300 Greater Mack Ave, Saint Clair Shores, MI 48080", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Warren", address: "3000 Van Dyke Ave, Warren, MI 48093", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Warren", address: "13700 E 14 Mile Rd, Warren, MI 48088", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Serves Warren, Saint Clair Shores, and eastern Macomb County. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Roseville", address: "27300 Gratiot Ave, Roseville, MI 48066", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Roseville, Eastpointe, and northern Macomb County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "Approximately 35 miles west of Saint Clair Shores via I-94",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for eastern Macomb County. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "DET",
      name: "Coleman A. Young Detroit City Airport",
      distance: "Approximately 15 miles southwest of Saint Clair Shores — domestic/charter only",
      address: "11499 Conner St, Detroit, MI 48213",
      note: "Smaller city airport primarily for charter and private flights. Not used for international travel. DTW remains the main gateway for international departures.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "Metro Airport Info",
      featured: false,
    },
  ],
};